// src/MyChatWindow.jsx
import React, { useEffect, useRef } from 'react';
// CSS principal do Chat
import '@n8n/chat/style.css';
import { createChat } from '@n8n/chat';
import ReplayIcon from "@mui/icons-material/Replay";
import {Button} from "@mui/material";

function MyChatWindow() {
  const chatContainerRef = useRef(null);

  useEffect(() => {
    createChat({
      webhookUrl: 'https://dev.api.foxid.com.br/webhook/3a45f7ca-a7c1-4cfe-8642-83831f607202/chat',
      mode: 'window',
      target: chatContainerRef.current,
      defaultLanguage: 'pt',
      showWelcomeScreen: false,
      initialMessages: [
      ],
      i18n: {
        pt: {
          title: 'ABES ChatBOT',
          subtitle: 'O ChatBOT ABES pode cometer alguns erros. Disponível 24h por dia, todos os dias. Nos envie seu feedback!',
          inputPlaceholder: 'Escreva sua pergunta :)',
        },
      },
    });
  }, []);

  // A div pode ter tamanho fixo ou pequeno, pois 'window' ignora as dimensões
  return (

    <div
      ref={chatContainerRef}
      style={{ width: '100%', height: '50px' }}
    />
  );
}

export default MyChatWindow;
